module.exports = __webpack_public_path__ + "media/src/assets/img/logo/logo-a5d6fa57427643c6ebe37859086c9a63.png";